import script from "./PharmacyInvoiceTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./PharmacyInvoiceTemplate.vue?vue&type=script&setup=true&lang=js"

import "./PharmacyInvoiceTemplate.vue?vue&type=style&index=0&id=062f7968&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-062f7968"]])

export default __exports__